import * as trigger from "./Lotus-Functions";

export function createLotusRender(p, lotus_webcam) {
  var soundInEased = 0;
  let pushPixelsPower, powerLine, powerLineSpd, pushPixelsPowerSpd;

  var mid = 0,
    treble = 0;

  let logo;

  var webcam;

  var W = 60;
  var H = 300;

  var S = 0,
    M = 0;

  var SRC;
  var FPS = 120;

  var FRAME = 0;

  var POINTS = [];
  var POINTS_IND = new Uint32Array(W * H);
  var POINTS_FADE = [];

  var rotX = 0.02;
  var rotY = Math.PI / 2;
  var rotXEased = rotX;
  var rotYEased = rotY;

  var previewScale = 500;
  var zDist = 0.0045;

  var pixelationList = [];
  var minPixelations = 40;
  var maxPixelations = 500;

  var shifts = [];
  var shiftedXs = [];
  var shiftedYs = [];

  var pixelsTemp = new Uint8ClampedArray(W * H * 4).fill(255);

  var camMin = 70;
  var camMax = 195;

  var brandColors = [
    [0, 0, 0],
    [16, 23, 36],
    [6, 46, 40],
    [50, 50, 50],
    [79, 79, 79],
    [150, 150, 150],
    [253, 239, 0],
    [253, 239, 0],
    [255, 255, 255],
  ];

  var CAMERA_SRC;

  const CAMERA_HEIGHT = 100;
  const CAMERA_SCALE = 3;
  const CAMERA_SCALE_X = CAMERA_SCALE;
  const CAMERA_SCALE_Y = CAMERA_SCALE * 1.1;

  var CAMERA_READY = false;
  var CAMERA_XVALUE = new Array(W).fill(0);
  var CAMERA_DIFF = new Array(W).fill(0);
  var CAMERA_DIFF_SUM = 0;

  class Pixelation {
    constructor() {
      this.size = trigger.chance(0.97) ? 5 : 10;
      this.x = trigger.randomn(W / this.size) * this.size;
      this.y = trigger.randomn(H / this.size) * this.size;
    }
    run(src) {
      let sum = 0;

      for (let x = 0; x < this.size; x++) {
        for (let y = 0; y < this.size; y++) {
          let ind = ((this.y + y) * W + this.x + x) * 4;
          sum += src[ind];
        }
      }
      sum /= this.size * this.size;
      sum = Math.floor(sum);

      for (let x = 0; x < this.size; x++) {
        for (let y = 0; y < this.size; y++) {
          let ind = ((this.y + y) * W + this.x + x) * 4;
          src[ind] = sum;
          src[ind + 1] = sum;
          src[ind + 2] = sum;
        }
      }
    }
  }

  function pixelation_add(count = 1) {
    for (let i = 0; i < count; i++)
      if (pixelationList.length < maxPixelations)
        pixelationList.push(new Pixelation());
  }

  function pixelation_remove(count = 1) {
    for (let i = 0; i < count; i++)
      if (pixelationList.length > minPixelations) {
        pixelationList.splice(trigger.randomn(pixelationList.length), 1);
      }
  }

  function pixelation(src) {
    for (let p of pixelationList) p.run(src);
  }

  function TIME() {
    return p.millis() * 0.001;
  }

  p.setup = function () {
    if (p.windowWidth > p.windowHeight) {
      p.createCanvas(700, 350);
    } else {
      p.createCanvas(500, 500);
    }
    p.frameRate(FPS);
    p.pixelDensity(1);
    p.loadPixels();

    SRC = p.createGraphics(W, H);
    SRC.pixelDensity(1);

    CAMERA_SRC = p.createGraphics(W, CAMERA_HEIGHT);
    CAMERA_SRC.pixelDensity(1);
    CAMERA_SRC.noSmooth();
    CAMERA_SRC.imageMode(p.CENTER);
    CAMERA_SRC.translate(W / 2, CAMERA_HEIGHT / 2);
    CAMERA_SRC.scale(-CAMERA_SCALE_X, CAMERA_SCALE_Y);

    POINTS = [
      [1.0002388, 0.20096284],
      [0.99967813, 0.19724403],
      [0.9990595, 0.19353445],
      [0.9983818, 0.18983522],
      [0.9976415, 0.18614799],
      [0.9968407, 0.18247344],
      [0.9959776, 0.178813],
      [0.99505013, 0.17516835],
      [0.9940604, 0.17154011],
      [0.99300534, 0.16793033],
      [0.99188495, 0.16434029],
      [0.9907015, 0.16077057],
      [0.98945, 0.15722412],
      [0.98813343, 0.15370129],
      [0.9867519, 0.15020344],
      [0.9853021, 0.14673334],
      [0.9837875, 0.14329103],
      [0.98220676, 0.13987856],
      [0.98055875, 0.13649808],
      [0.97884727, 0.13314934],
      [0.97706896, 0.12983553],
      [0.97522634, 0.12655711],
      [0.9733204, 0.123315],
      [0.97134984, 0.120111845],
      [0.9693171, 0.116947755],
      [0.9672236, 0.11382351],
      [0.9650671, 0.1107424],
      [0.9628518, 0.10770331],
      [0.9605787, 0.1047073],
      [0.95824623, 0.101757094],
      [0.95585877, 0.098851375],
      [0.95341575, 0.09599208],
      [0.95091873, 0.093179934],
      [0.94837034, 0.09041412],
      [0.94576937, 0.087697834],
      [0.94311976, 0.085028894],
      [0.94042313, 0.08240747],
      [0.93767804, 0.07983687],
      [0.93488854, 0.07731449],
      [0.93205583, 0.0748408],
      [0.92917955, 0.072417736],
      [0.92626345, 0.07004295],
      [0.92330784, 0.06771744],
      [0.9203136, 0.065441795],
      [0.91728395, 0.06321365],
      [0.91421825, 0.0610353],
      [0.9111192, 0.058904625],
      [0.90798825, 0.05682117],
      [0.90482485, 0.054787364],
      [0.9016325, 0.052799188],
      [0.89841145, 0.050857786],
      [0.8951624, 0.04896384],
      [0.89188755, 0.047114745],
      [0.8885873, 0.045311313],
      [0.8852627, 0.043553215],
      [0.8819158, 0.041838],
      [0.8785462, 0.040167764],
      [0.87515575, 0.03854032],
      [0.8717455, 0.03695471],
      [0.8683154, 0.03541257],
      [0.8648673, 0.033910867],
      [0.86140186, 0.032450072],
      [0.85791934, 0.031030217],
      [0.8544212, 0.02964924],
      [0.8509078, 0.028307676],
      [0.84737974, 0.02700494],
      [0.8438383, 0.025739474],
      [0.8402832, 0.024512215],
      [0.8367158, 0.0233216],
      [0.83313686, 0.022166418],
      [0.82954603, 0.021048343],
      [0.8259447, 0.019964522],
      [0.8223331, 0.018915344],
      [0.81871164, 0.01790129],
      [0.81508106, 0.016919782],
      [0.8114416, 0.015972057],
      [0.8077938, 0.015056886],
      [0.8041381, 0.014173579],
      [0.8004749, 0.013322329],
      [0.7968045, 0.012502504],
      [0.79312754, 0.011712627],
      [0.7894439, 0.010954098],
      [0.78575444, 0.010225022],
      [0.7820592, 0.009525411],
      [0.77835846, 0.008855491],
      [0.7746528, 0.008213609],
      [0.7709423, 0.0076001757],
      [0.76722723, 0.0070151393],
      [0.763508, 0.0064570787],
      [0.7597847, 0.0059268503],
      [0.7560577, 0.005423365],
      [0.75232726, 0.004945901],
      [0.7485934, 0.0044956557],
      [0.74485666, 0.0040708124],
      [0.741117, 0.0036713798],
      [0.7373748, 0.0032979313],
      [0.7336302, 0.0029490357],
      [0.7298833, 0.002624974],
      [0.7261343, 0.0023259392],
      [0.72238356, 0.002050465],
      [0.718631, 0.0017995113],
      [0.7148771, 0.0015721126],
      [0.7111218, 0.0013679184],
      [0.7073652, 0.0011878945],
      [0.7036077, 0.0010305536],
      [0.6998492, 8.9590746e-4],
      [0.69609, 7.84625e-4],
      [0.6923301, 6.955042e-4],
      [0.68856984, 6.2862976e-4],
      [0.68480927, 5.845587e-4],
      [0.68104845, 5.6189956e-4],
      [0.67728764, 5.5982533e-4],
      [0.6735269, 5.815238e-4],
      [0.66976625, 6.246851e-4],
      [0.66600597, 6.89838e-4],
      [0.6622461, 7.7595894e-4],
      [0.65848684, 8.829178e-4],
      [0.6547282, 0.0010109573],
      [0.6509702, 0.0011588661],
      [0.6472131, 0.0013269079],
      [0.64345706, 0.0015150564],
      [0.63970184, 0.0017222989],
      [0.6359478, 0.0019491927],
      [0.632195, 0.0021949878],
      [0.6284434, 0.0024591265],
      [0.6246933, 0.0027423399],
      [0.62094444, 0.0030434842],
      [0.6171971, 0.0033622733],
      [0.6134514, 0.003699526],
      [0.6097073, 0.0040535983],
      [0.60596484, 0.00442504],
      [0.6022241, 0.0048138467],
      [0.5984852, 0.0052188225],
      [0.5947481, 0.0056407074],
      [0.59101284, 0.006078923],
      [0.5872795, 0.0065328907],
      [0.5835482, 0.007003178],
      [0.57981884, 0.0074888864],
      [0.5760915, 0.007989824],
      [0.5723663, 0.008506532],
      [0.56864315, 0.009037786],
      [0.56492215, 0.00958396],
      [0.56120336, 0.010145044],
      [0.5574868, 0.010720103],
      [0.5537724, 0.011309647],
      [0.5500604, 0.011913272],
      [0.54635054, 0.012530397],
      [0.5426431, 0.013161809],
      [0.5389378, 0.013806328],
      [0.53523487, 0.01446395],
      [0.53153443, 0.015135254],
      [0.52783626, 0.015819209],
      [0.5241405, 0.016515885],
      [0.5204472, 0.017225483],
      [0.5167563, 0.017947255],
      [0.5130677, 0.018681431],
      [0.5093817, 0.019427795],
      [0.5056981, 0.02018592],
      [0.50201696, 0.020956295],
      [0.49833828, 0.02173811],
      [0.494662, 0.022531228],
      [0.4909883, 0.023336167],
      [0.48731703, 0.024152052],
      [0.48364827, 0.024979066],
      [0.479982, 0.025817188],
      [0.47631818, 0.026665905],
      [0.4726569, 0.02752541],
      [0.4689981, 0.028395485],
      [0.46534172, 0.02927576],
      [0.46168792, 0.030166566],
      [0.45803654, 0.031067424],
      [0.45438758, 0.03197814],
      [0.45074126, 0.032899063],
      [0.44709742, 0.033829544],
      [0.44345593, 0.03476964],
      [0.439817, 0.035719484],
      [0.43618047, 0.036678497],
      [0.4325465, 0.037646845],
      [0.42891493, 0.038624544],
      [0.42528576, 0.039611097],
      [0.42165914, 0.040606808],
      [0.41803488, 0.041611213],
      [0.41441306, 0.042624217],
      [0.4107938, 0.043646276],
      [0.40717685, 0.04467659],
      [0.4035623, 0.045715302],
      [0.39995015, 0.046762496],
      [0.3963404, 0.047817726],
      [0.392733, 0.048881203],
      [0.389128, 0.049952712],
      [0.38552532, 0.051031943],
      [0.38192502, 0.052119233],
      [0.37832713, 0.05321423],
      [0.3747315, 0.054316662],
      [0.3711383, 0.055426862],
      [0.3675473, 0.05654445],
      [0.36395866, 0.057669315],
      [0.36037228, 0.058801584],
      [0.35678813, 0.059940957],
      [0.3532063, 0.061087478],
      [0.34962672, 0.06224101],
      [0.34604937, 0.06340138],
      [0.3424743, 0.06456874],
      [0.3389014, 0.06574277],
      [0.3353307, 0.06692339],
      [0.33176225, 0.06811087],
      [0.3281959, 0.06930465],
      [0.32463172, 0.07050491],
      [0.32106978, 0.071711674],
      [0.31750983, 0.07292452],
      [0.3139521, 0.07414371],
      [0.31039643, 0.075369075],
      [0.30684283, 0.07660029],
      [0.30329144, 0.07783771],
      [0.29974204, 0.07908097],
      [0.29619464, 0.08032995],
      [0.29264933, 0.08158491],
      [0.289106, 0.08284541],
      [0.28556463, 0.08411153],
      [0.28202534, 0.08538335],
      [0.2784879, 0.086660504],
      [0.27495244, 0.08794318],
      [0.27141893, 0.08923124],
      [0.26788738, 0.09052439],
      [0.26435784, 0.09182286],
      [0.26083004, 0.09312651],
      [0.2573042, 0.09443505],
      [0.2537803, 0.095748805],
      [0.25025815, 0.09706747],
      [0.24673784, 0.0983909],
      [0.24321938, 0.099719346],
      [0.23970264, 0.10105242],
      [0.23618777, 0.10239017],
      [0.23267455, 0.10373265],
      [0.22916317, 0.10507954],
      [0.22565351, 0.10643108],
      [0.22214556, 0.107786976],
      [0.21863922, 0.10914722],
      [0.21513468, 0.11051194],
      [0.21163172, 0.111880764],
      [0.20813039, 0.11325381],
      [0.2046307, 0.11463107],
      [0.20113267, 0.11601228],
      [0.19763629, 0.117397524],
      [0.19414142, 0.11878677],
      [0.19064799, 0.12017985],
      [0.18715625, 0.12157679],
      [0.18366592, 0.12297751],
      [0.18017708, 0.12438186],
      [0.17668977, 0.12578999],
      [0.17320387, 0.12720165],
      [0.16971941, 0.12861675],
      [0.16623639, 0.13003546],
      [0.16275467, 0.13145752],
      [0.15927432, 0.13288295],
      [0.15579537, 0.13431169],
      [0.15231773, 0.13574359],
      [0.14884146, 0.13717873],
      [0.1453664, 0.13861701],
      [0.14189261, 0.14005822],
      [0.13842015, 0.14150244],
      [0.13494882, 0.14294958],
      [0.13147867, 0.14439964],
      [0.12800977, 0.14585257],
      [0.124542005, 0.14730819],
      [0.12107524, 0.1487665],
      [0.11760974, 0.15022746],
      [0.11414527, 0.15169093],
      [0.11068187, 0.15315694],
      [0.10721954, 0.15462534],
      [0.103758186, 0.15609607],
      [0.10029778, 0.15756918],
      [0.09683833, 0.1590445],
      [0.09337987, 0.16052195],
      [0.089922205, 0.16200161],
      [0.086465396, 0.16348326],
      [0.083009556, 0.16496684],
      [0.07955448, 0.16645238],
      [0.07610023, 0.16793966],
      [0.072646745, 0.16942878],
      [0.06919393, 0.17091958],
      [0.065741815, 0.17241196],
      [0.06229044, 0.17390592],
      [0.058839582, 0.17540137],
      [0.05538944, 0.17689814],
      [0.051939804, 0.1783963],
      [0.04849071, 0.17989565],
      [0.045042165, 0.18139616],
      [0.041594002, 0.1828978],
      [0.038146295, 0.18440038],
      [0.034699, 0.18590389],
      [0.031252053, 0.18740816],
      [0.027805416, 0.18891318],
      [0.024359096, 0.19041885],
      [0.020912997, 0.19192506],
      [0.017467031, 0.19343178],
      [0.014021221, 0.19493885],
      [0.010575566, 0.19644614],
      [0.007129949, 0.1979536],
      [0.00368435, 0.1994611],
    ];

    webcam = lotus_webcam.source;

    generateMapping();

    powerLine = 0;
    powerLineSpd = 0.2;

    pushPixelsPower = 0;
    pushPixelsPowerSpd = 0;

    logo = p.loadImage(
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAkCAMAAADip6m2AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDkuMS1jMDAxIDc5LmE4ZDQ3NTM0OSwgMjAyMy8wMy8yMy0xMzowNTo0NSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDI0LjYgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RDBFQzhFMDcyRjM1MTFFRTgxRUZGQkQ1NkQwMjc0NzciIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RDBFQzhFMDgyRjM1MTFFRTgxRUZGQkQ1NkQwMjc0NzciPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpEMEVDOEUwNTJGMzUxMUVFODFFRkZCRDU2RDAyNzQ3NyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpEMEVDOEUwNjJGMzUxMUVFODFFRkZCRDU2RDAyNzQ3NyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PgyNxrkAAAAGUExURQAAAP///6XZn90AAABmSURBVHja7NQ5DsAgDETR4f6XTsWiYViUNL+IKwt4SBbGklRqqEbLbavl/TADWz4DJh5rNhyvhuCbmiHYuurYYQRcPsSPX+DYZHHu+HPC8Liy+hVYHD8MH8dZj8I26zcdxsCPAAMAA2QFdBZa/FIAAAAASUVORK5CYII=",
      () => logo.loadPixels()
    );

    pixelation_add(minPixelations);
  };

  p.draw = function () {
    S = M;
    M = TIME();
    S = (M - S) * FPS;

    if (webcam === undefined) return;

    SRC.loadPixels();

    updateCamera();
    updateScreen();

    if (p.mouseIsPressed) {
      rotX += (p.mouseY - p.pmouseY) * 0.002;
      rotX = trigger.constrain(rotX, -0.1, 0.5);
      rotY -= (p.mouseX - p.pmouseX) * 0.002;
    }

    rotXEased = trigger.eased(rotXEased, rotX, 0.1);
    rotYEased = trigger.eased(rotYEased, rotY, 0.1);

    if (rotXEased != rotX || rotYEased != rotY) generateMapping();

    for (let i = 0; i < p.pixels.length / 4; i++) {
      p.pixels[i * 4] = 0;
      p.pixels[i * 4 + 1] = 0;
      p.pixels[i * 4 + 2] = 0;
      p.pixels[i * 4 + 3] = 255;
    }

    for (let y = 0; y < H; y++) {
      for (let x = 0; x < W; x++) {
        let sind = ((H - y - 1) * W + x) * 4;
        let fade = POINTS_FADE[y * W + x];

        for (let xx = 0; xx < 2; xx++) {
          for (let yy = 0; yy < 2; yy++) {
            let dind = POINTS_IND[y * W + x] + (xx + yy * p.width) * 4;
            p.pixels[dind] += Math.floor(SRC.pixels[sind] * fade);
            p.pixels[dind + 1] += Math.floor(SRC.pixels[sind + 1] * fade);
            p.pixels[dind + 2] += Math.floor(SRC.pixels[sind + 2] * fade);
          }
        }
      }
    }

    p.updatePixels();

    FRAME++;
  };

  function calculatePointPositionWithPerspective(
    x3d,
    y3d,
    z3d,
    rotationX,
    rotationY,
    cameraX,
    cameraY,
    cameraZ
  ) {
    var cosX = Math.cos(rotationX);
    var sinX = Math.sin(rotationX);
    var cosY = Math.cos(rotationY);
    var sinY = Math.sin(rotationY);

    var rotatedX = x3d * cosY + z3d * sinY;
    var rotatedY = x3d * sinX * sinY + y3d * cosX - z3d * sinX * cosY;
    var rotatedZ = -x3d * sinY + z3d * cosY;

    var perspectiveFactor = cameraZ / (cameraZ + rotatedZ);
    var x = rotatedX * perspectiveFactor;
    var y = rotatedY * perspectiveFactor;

    var fade = trigger.fmap(rotatedZ, 0, -previewScale * 0.5, 0.05, 1);

    return [x, y, fade];
  }

  function generateMapping() {
    for (let y = 0; y < H; y++) {
      for (let x = 0; x < W; x++) {
        let [cx, cy, fade] = calculatePointPositionWithPerspective(
          (POINTS[y][0] - 0.5) * previewScale,
          (POINTS[y][1] - 0.15) * previewScale,
          (x - W / 2) * zDist * previewScale,
          rotXEased,
          rotYEased,
          0,
          0,
          380
        );

        cx = trigger.constrain(
          Math.floor(p.width / 2) + Math.floor(cx),
          0,
          p.width - 1
        );
        cy = trigger.constrain(
          Math.floor(p.height / 2) + Math.floor(cy),
          0,
          p.height - 1
        );

        let dind = (cy * p.width + cx) * 4;

        POINTS_IND[y * W + x] = dind;
        POINTS_FADE[y * W + x] = fade;
      }
    }
  }

  function updateCamera() {
    CAMERA_SRC.image(webcam, 0, 0, W, (W * webcam.height) / webcam.width);

    CAMERA_SRC.loadPixels();

    trigger.greyscale(CAMERA_SRC.pixels, camMin, camMax);

    CAMERA_SRC.updatePixels();

    for (let r = 0; r < H / CAMERA_HEIGHT; r++) {
      SRC.image(CAMERA_SRC, 0, r * CAMERA_HEIGHT, W, CAMERA_HEIGHT);
    }

    CAMERA_DIFF_SUM = 0;

    for (let x = 0; x < W; x++) {
      let temp = CAMERA_XVALUE[x];
      CAMERA_XVALUE[x] = 0;

      for (let y = 0; y < CAMERA_HEIGHT; y++) {
        let ind = (y * W + x) * 4;
        CAMERA_XVALUE[x] += CAMERA_SRC.pixels[ind] / 255.0;
      }

      CAMERA_XVALUE[x] /= CAMERA_HEIGHT;
      CAMERA_DIFF[x] *= 0.95;
      let diff = Math.abs(CAMERA_XVALUE[x] - temp);
      if (diff > 0.02) CAMERA_DIFF[x] += diff;
      CAMERA_DIFF[x] = trigger.constrain(CAMERA_DIFF[x], 0, 1);

      CAMERA_DIFF_SUM += CAMERA_DIFF[x];
    }

    CAMERA_DIFF_SUM /= W;
  }

  function updateScreen() {
    pixelation_remove(10);
    if (FRAME % 24 == 0) {
      let count = trigger.fmap(
        treble * 100 + p.noise(FRAME * 0.01),
        0.55,
        0.9,
        0,
        500
      );
      pixelation_add(count);
    }
    if (trigger.chance(0.0001)) pixelation_add(600);

    pixelation(SRC.pixels);

    drawLogo(logo, SRC, 0, 204);

    pushPixelsPower -= 0.05 + soundInEased;
    pushPixels(SRC, 0, pushPixelsPower);

    powerLine += 0.5 + soundInEased * 10;
    greyScaleNoisePXGradient({
      startPos: -powerLine,
      heightPerc: 0.2,
      gap: 1,
      opacity: 0.5 + soundInEased * 1,
    });

    trigger.gradientMap(SRC.pixels, brandColors);

    // DODGE SHIFT

    // if(chance(0.1 * (0.05 + CAMERA_DIFF_SUM ) )) {
    if (trigger.chance(0.001)) {
      let spd = p.random(0.01, 0.02);
      let del = trigger.chance(0.3) ? 0 : trigger.randomr(120, 600);
      let xs = trigger.randomn(W / 2);
      let xw = trigger.randomn(W / 2 - xs);

      for (let x = 0; x < xw; x++) {
        addShift({
          start: xs + x,
          backwards: false,
          delay: x * del,
          direction: "tb",
          size: 1,
          speed: spd,
        });
        addShift({
          start: W - xs - x - 1,
          backwards: false,
          delay: x * del,
          direction: "tb",
          size: 1,
          speed: spd,
        });
      }
    }

    // AERO

    // if(chance(0.005 * (0.05 + CAMERA_DIFF_SUM ) )) {
    if (trigger.chance(0.0005)) {
      let spd = p.random(0.01, 0.02);
      let del = trigger.randomr(120, 600);
      let phases = Math.pow(2, trigger.randomn(3));
      for (let x = 0; x < W; x++)
        addShift({
          start: x,
          backwards: false,
          delay: ((1 + Math.cos((x / W) * 2 * Math.PI * phases)) / 2) * del,
          direction: "tb",
          size: 1,
          speed: spd,
        });
    }

    // SLICE

    // if(chance(0.002 * (0.05 + CAMERA_DIFF_SUM ) )) {
    if (trigger.chance(mid * 0.01 + 0.004)) {
      let w = trigger.chance(0.7) ? 5 : trigger.chance(0.7) ? 10 : 20;
      addShift({
        start: trigger.randomn(W / w) * w,
        size: w,
        direction: "tb",
        backwards: false,
        speed: p.random(0.01, 0.025),
      });
    }

    // LINES

    for (let x = 0; x < W; x++)
      if (trigger.chance(mid * 0.1 + CAMERA_DIFF[x] * 0.05)) {
        addShift({
          start: x,
          backwards: false,
          direction: "tr",
          speed: p.random(0.01, 0.05),
        });
      }

    shift(SRC);
  }

  class Shift {
    constructor({
      start,
      direction = trigger.chance(0.5) ? "lr" : "tb",
      backwards = trigger.chance(0.5),
      size = 1,
      delay = 0,
      lng,
      speed = p.random(1, 3) * 0.005,
    } = {}) {
      this.finished = false;
      this.direction = direction == "lr";
      this.backwards = backwards;
      this.speed = speed;
      this.progress = 0;
      this.startTime = p.millis() + delay;
      this.size = size;
      this.full = lng === undefined;
      this.length = lng === undefined ? (this.direction ? W : H) : lng;
      this.return = false;
      if (start !== undefined) this.start = start;
      else {
        if (this.direction) {
          this.start = trigger.randomn(H / this.size) * this.size;
        } else {
          this.start = trigger.randomn(W / this.size) * this.size;
        }
      }
      this.end = this.start + this.size;
    }
    shift() {
      if (this.startTime > p.millis()) return;
      this.progress += this.speed * (this.return ? -1 : 1) * S;
      let progressBeziered = 0;
      if (this.progress > 1) {
        this.progress = 1;
        progressBeziered = 1;
      } else {
        progressBeziered = trigger.beziered(
          this.progress,
          2,
          1,
          0,
          1,
          0.2,
          0.9
        );
      }
      if (this.progress < 0 || (this.full && this.progress >= 1)) {
        this.finished = true;
        return;
      }
      if (this.direction) {
        for (let y = this.start; y < this.end; y++)
          shiftedYs[y] +=
            Math.ceil(progressBeziered * this.length) *
            (this.backwards ? -1 : 1);
      } else {
        for (let x = this.start; x < this.end; x++)
          shiftedXs[x] +=
            Math.ceil(progressBeziered * this.length) *
            (this.backwards ? -1 : 1);
      }
    }
  }

  function addShift(options, count = 1) {
    for (let i = 0; i < count; i++) shifts.push(new Shift(options));
  }

  function shift(src) {
    for (let x = 0; x < W; x++) shiftedXs[x] = 0;
    for (let y = 0; y < H; y++) shiftedYs[y] = 0;

    for (let i = shifts.length - 1; i >= 0; i--) {
      if (shifts[i].finished) {
        shifts.splice(i, 1);
      } else {
        shifts[i].shift();
      }
    }

    if (shifts.length == 0) return;

    let id, xs, ys, is;
    for (let x = 0; x < W; x++) {
      for (let y = 0; y < H; y++) {
        id = (y * W + x) * 4;
        xs = (x + shiftedYs[y]) % W;
        if (xs < 0) xs += W;
        ys = (y + shiftedXs[x]) % H;
        if (ys < 0) ys += H;
        is = (ys * W + xs) * 4;
        pixelsTemp[id] = src.pixels[is];
        pixelsTemp[id + 1] = src.pixels[is + 1];
        pixelsTemp[id + 2] = src.pixels[is + 2];
      }
    }

    src.pixels.set(pixelsTemp);
  }

  function drawLogo(src, dst, tx = 0, ty = 0) {
    for (let x = 0; x < W; x++) {
      for (let y = 0; y < src.height; y++) {
        let inds = (y * W + x) * 4;
        let indd = ((ty + y) * W + (tx + x)) * 4;
        if (src.pixels[inds] == 0) {
          dst.pixels[indd] = 255;
          dst.pixels[indd + 1] = 255;
          dst.pixels[indd + 2] = 255;
          dst.pixels[indd + 3] = 255;
        }
      }
    }
  }

  function pushPixels(src, px, py) {
    px = Math.floor(px);
    py = Math.floor(py);
    for (let y = 0; y < H; y++) {
      for (let x = 0; x < W; x++) {
        let isrc = (y * W + x) * 4;
        let idst = (trigger.mod(y + py, H) * W + trigger.mod(x + px, W)) * 4;
        pixelsTemp[idst] = src.pixels[isrc];
        pixelsTemp[idst + 1] = src.pixels[isrc + 1];
        pixelsTemp[idst + 2] = src.pixels[isrc + 2];
      }
    }
    src.pixels.set(pixelsTemp);
  }

  function greyScaleNoisePXGradient({
    power = 1,
    heightSpd = 0.3,
    posSpd = 0.7,
    transSpd = 1,
    startPos = 0,
    heightPerc = 0.5,
    gap = 1.2,
    opacity = 1,
  }) {
    if (opacity > 1) opacity = 1;
    let h = H * heightPerc;
    let s = Math.floor(startPos);

    for (let y = 0; y < h; y++) {
      let transparency = Math.sin((y / h) * Math.PI) * 255;
      transparency *= opacity;
      PXrect(
        SRC.pixels,
        0,
        trigger.mod(s + y - h / 2, Math.floor(H * gap)),
        W,
        1,
        [255, 255, 255],
        transparency
      );
    }
  }

  function PXrect(
    src = p.pixels,
    posx,
    posy,
    w,
    h,
    rgb = [255, 255, 255],
    a = 255,
    srcw = W,
    srch = H,
    wrap = false
  ) {
    for (let x = 0; x < w; x++) {
      for (let y = 0; y < h; y++) {
        PX(
          src,
          wrap ? trigger.mod(posx + x, srch) : posx + x,
          wrap ? trigger.mod(posy + y, srch) : posy + y,
          rgb[0],
          rgb[1],
          rgb[2],
          a,
          srcw,
          srch
        );
      }
    }
  }

  function PX(
    src = p.pixels,
    x,
    y,
    r = 255,
    g = 255,
    b = 255,
    a = 255,
    srcw = W,
    srch = H
  ) {
    x = Math.floor(x);
    y = Math.floor(y);
    if (x >= 0 && x < srcw && y >= 0 && y < srch) {
      let i = (y * srcw + x) * 4;
      if (a == 255) {
        src[i] = Math.floor(r);
        src[i + 1] = Math.floor(g);
        src[i + 2] = Math.floor(b);
      } else {
        src[i] = Math.floor(src[i] + (a / 255) * (r - src[i]));
        src[i + 1] = Math.floor(src[i + 1] + (a / 255) * (g - src[i + 1]));
        src[i + 2] = Math.floor(src[i + 2] + (a / 255) * (b - src[i + 2]));
      }
    }
  }
}
